/**
 * Staging environment configuration.
 */
export const environment = {
  production: false,
  envName: 'Dev',
  apiBaseUrl: 'https://dev.api.donoratlas.com/v1/integrations/external/re',
  donoratlasFrontendUrl: 'https://dev.donoratlas.com',
};
